import { api } from '@/api/client';

/**
 * Downloads an Excel file from an authenticated API endpoint.
 * Uses Axios so the JWT Authorization header is included automatically.
 */
export async function downloadExcel(url: string, filename: string, timeoutMs?: number): Promise<void> {
  // Allow a longer timeout than the client default (30s) for large, uncapped
  // exports so a big dataset can't be cut off mid-download.
  const response = await api.get(url, { responseType: 'blob', ...(timeoutMs ? { timeout: timeoutMs } : {}) });
  saveBlob(response.data, filename);
}

/** Same, for an export whose rows are sent in the request body (reports built in the browser). */
export async function postDownloadExcel(url: string, body: unknown, filename: string, timeoutMs = 120000): Promise<void> {
  const response = await api.post(url, body, { responseType: 'blob', timeout: timeoutMs });
  saveBlob(response.data, filename);
}

function saveBlob(data: BlobPart, filename: string) {
  const blob = new Blob([data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(objectUrl);
}
